import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuypolska.com";

const faqs = [
  {
    question: "Czym jest Kakobuy Spreadsheet?",
    answer:
      "Kakobuy Spreadsheet to zorganizowana baza produktów z Chin z gotowymi linkami, zdjęciami QC i informacjami o cenach. Dzięki niej nie musisz przeszukiwać setek stron — wszystkie najlepsze produkty są w jednym miejscu.",
  },
  {
    question: "Czy Kakobuy Spreadsheet jest darmowy?",
    answer:
      "Tak, dostęp do podstawowej bazy produktów jest całkowicie darmowy. Możesz przeglądać kategorie, linki i produkty bez żadnych opłat.",
  },
  {
    question: "Jak często aktualizowana jest baza?",
    answer:
      "Baza jest aktualizowana regularnie, zazwyczaj kilka razy w tygodniu. Nowe produkty pojawiają się wraz z nowymi znaleziskami społeczności.",
  },
  {
    question: "Czy zakupy na Kakobuy są bezpieczne?",
    answer:
      "Tak, Kakobuy to sprawdzona platforma agentska. Zalecamy sprawdzać QC zdjęcia przed zatwierdzeniem wysyłki.",
  },
  {
    question: "Jak długo trwa wysyłka do Polski?",
    answer:
      "Wysyłka do Polski zazwyczaj trwa od 10 do 25 dni roboczych w zależności od wybranej linii wysyłkowej.",
  },
  {
    question: "Co to są QC zdjęcia?",
    answer:
      "QC (Quality Control) to zdjęcia produktów wykonane przez magazyn po dostarczeniu zamówienia. Pokazują rzeczywisty wygląd produktu przed wysyłką.",
  },
  {
    question: "Jak korzystać z Kakobuy Spreadsheet?",
    answer:
      "Wybierz kategorię produktów, znajdź interesujący Cię przedmiot, sprawdź link i informacje QC, a następnie kliknij przycisk zakupu.",
  },
  {
    question: "Czy mogę zwrócić produkt?",
    answer:
      "Kakobuy oferuje możliwość zwrotu produktów do magazynu w Chinach przed wysyłką międzynarodową. Po wysłaniu zwroty są już niemożliwe.",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
};

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="min-h-[100dvh] flex flex-col">
      <JsonLd data={faqJsonLd} />
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                Najczęściej zadawane pytania
              </h1>
              <p className="text-sm md:text-base text-foreground-600">
                Odpowiedzi na najpopularniejsze pytania o Kakobuy Spreadsheet
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {faqs.map((faq, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-50/50 transition-colors"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`ri-add-line text-lg text-primary-500 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-45" : ""}`}
                    />
                  </button>
                  <div
                    className={`px-5 overflow-hidden transition-all duration-300 ease-out ${openIndex === i ? "max-h-96 pb-5" : "max-h-0"}`}
                  >
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-10">
              <p className="text-sm text-foreground-600 mb-4">
                Masz więcej pytań? Sprawdź nasz przewodnik lub przejdź bezpośrednio do sklepu.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/blog/kakobuy-spreadsheet-kompletny-przewodnik"
                  className="inline-flex items-center gap-2 bg-background-100 text-foreground-950 text-sm font-medium px-6 py-2.5 rounded-full border border-background-300 hover:bg-background-200 transition-colors whitespace-nowrap"
                >
                  Przeczytaj pełny przewodnik
                  <i className="ri-book-open-line" />
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-6 py-2.5 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  Przejdź do Kakobuy
                  <i className="ri-external-link-line" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}